import React from "react";
import style from "../../Styles/Components/DistributionCard.module.css";
import {dateUtil} from "../../Lib/Utils";

const DistributionCard = ({ history, ELocale, isFirst, isLast, onClick, isOpen}) => (
  <div className={style.container}>
    <div className={style.lineContainer}>
      {/* <div className={style.upperLine} style={{ borderRightWidth: isFirst ? 0 : 2 }} /> */}
      <div className={style.lowerLine} style={{ borderRightWidth: isLast ? 0 : 2 }} />
      <div className={style.pointContainer}>
        <img className={style.point} src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-point.svg"} alt="point" />
      </div>
    </div>
    <div className={style.cardContainer}>
      <div className={style.top}>
        <div className={style.timeContainer}>
          <img className={style.clockIcon} src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-time-dark.svg"} alt="clockIcon" />
          <span className={style.time}>
            {ELocale === 'kr' ? dateUtil.format("YYYY년 M월 D일, a H:mm", new Date(history.createdAt)) : dateUtil.format("llll", new Date(history.createdAt))}
          </span>
        </div>
        <img
          onClick={history.onClick}
          className={style.arrDownIcon}
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/arr-down.svg"}
          alt="clockIcon"
        />
      </div>
      <div>
        <span className={style.location}>{history.confirmGeoCode ? history.confirmGeoCode.city  + ", " +history.confirmGeoCode.country : ''}</span>
      </div>
      <div style={{ marginTop: 9 }}>
        {ELocale === 'kr' ?
        <span className={style.title}>
          <span className={style.bold}>{history.distributorName}님</span>
          {"에게 "}
          <span className={style.bold}>인수</span>
          되었습니다.
        </span> :
          <span className={style.title}>
          <span className={style.bold}>Taken over</span>
            {" by "}
            <span className={style.bold}>{history.distributorName}.</span>
        </span>}
      </div>
      {isOpen ?
      <div>
        <img src={history.mapUrl} alt={'map_image'} style={{width: '98%', marginTop: '10px'}}/>
      </div> : null}
    </div>
  </div>
);

export default DistributionCard;
